<template>
    <span class="mb-1">
        <badge v-if="markedAsFraud" type="danger">
            Fraudulent
        </badge>
    </span>
</template>
<script>
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        markedAsFraud: {
            type: Boolean
        }
    }
}
</script>

<style lang="scss" scoped>
.p-badge {
    margin-right: 0.25rem;
}
</style>
